import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const SingleItem = ({ data, handleClose }) => {
  const [livePrice, setLivePrice] = useState([]);
  const [loading, setLoading] = useState(true);
  const { forex_id: forexData } = data;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [livePrice]);

  const fetchData = async () => {
    if (forexData !== null) {
      fetch(
        `https://api.massive.com/v2/snapshot/locale/global/markets/forex/tickers/C:${forexData?.base_currency}${forexData?.quote_currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.ticker) {
            setLivePrice(data?.ticker);
          }
          if (loading) {
            setLoading(false);
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
  };

  if (loading || forexData === null) {
    return;
  }

  return (
    <>
      <li>
        <NavLink
          onClick={handleClose}
          className="menu-item "
          to={`/user/live/trade/forex/${forexData?._id}`}
        >
          <div className="d-flex justify-content-between gap-1">
            <div className="text-xl">
              <span>{forexData?.name}</span>
              <span className="opacity-50 text-base font-light">
                <br />
                {forexData?.base_currency}
                {forexData?.quote_currency}
              </span>
            </div>
            <div className="d-flex justify-content-between mt-1">
            {livePrice?.lastQuote?.a !== 0 && livePrice?.lastQuote?.a  && (
                <div className="text-gray-400 font-light text-sm  trade-sidebar-price">
                  {!isNaN(livePrice?.lastQuote?.a) &&
                    parseFloat(livePrice?.lastQuote?.a) +
                      parseFloat(forexData?.price)}
                  $
                </div>
              )}
              {livePrice?.lastQuote?.a === 0 ? (
                <div className="text-gray-400 font-light text-sm  trade-sidebar-price">
                  closed
                </div>
              ) : !livePrice?.lastQuote?.a  && <div className="text-gray-400 font-light text-sm  trade-sidebar-price">
              closed
            </div>}
            </div>
          </div>
        </NavLink>
      </li>
    </>
  );
};

export default SingleItem;
